<div class="dashboard-widget-content p-2">
    <rask-alert-list
        [data]="events$"
        title="Avverkning">
        <ng-template #icons raskAlertItem let-item>
            <img [src]="item.metadata.iconUrl | aoIconUrl" />
        </ng-template>
    </rask-alert-list>
</div>